/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Text } from '@zillow/constellation-10';
import { formatStackedNumbers } from '../../utils';
import { isNumber } from '../../utils/isNumber';

const getLabelTypeAdornment = (labelType: string, entry: any) => {
  switch (labelType) {
    case 'default':
      return (
        <span
          style={{
            display: 'inline-block',
            width: '16px',
            height: '16px',
            backgroundColor: entry.color,
            marginRight: '5px',
            borderRadius: '50%',
            verticalAlign: 'middle',
          }}
        />
      );
    case 'line':
      return (
        <Text
          css={{
            display: 'inline-block',
            width: '16px',
            borderBottom: '3px solid',
            verticalAlign: 'middle',
            marginRight: '5px',
          }}
          style={{ borderColor: entry.color }}
        >
          {' '}
        </Text>
      );
    case 'dashed-line':
      return (
        <Text
          css={{
            display: 'inline-block',
            width: '16px',
            borderBottom: '3px dashed',
            verticalAlign: 'middle',
            marginRight: '5px',
          }}
          style={{ borderColor: entry.color }}
        >
          {' '}
        </Text>
      );
    case 'striped':
      return (
        <svg
          width="16"
          height="16"
          style={{
            display: 'inline-block',
            marginRight: '5px',
            verticalAlign: 'middle',
          }}
        >
          <defs>
            <pattern
              id="legend-stripe"
              patternUnits="userSpaceOnUse"
              width="6"
              height="6"
              patternTransform="rotate(45)"
            >
              <rect width="6" height="6" fill="#B88DFC" />
              <rect width="3" height="6" fill="#891EFA" />
            </pattern>
          </defs>
          <rect width="16" height="16" fill="url(#legend-stripe)" rx="8" ry="8" />
        </svg>
      );
    case 'striped-teal':
      return (
        <svg
          width="16"
          height="16"
          style={{
            display: 'inline-block',
            marginRight: '5px',
            verticalAlign: 'middle',
          }}
        >
          <defs>
            <pattern
              id="legend-stripe-teal"
              patternUnits="userSpaceOnUse"
              width="6"
              height="6"
              patternTransform="rotate(45)"
            >
              <rect width="6" height="6" fill="#73D4E4" />
              <rect width="3" height="6" fill="#009AAE" />
            </pattern>
          </defs>
          <rect width="16" height="16" fill="url(#legend-stripe-teal)" rx="8" ry="8" />
        </svg>
      );
  }
};

export const CustomGraphLegend = (props: any) => {
  const {
    payload,
    formatter = (value: any) => (isNumber(value) ? formatStackedNumbers(value) : value),
    labelTypes = {},
    filterPayload,
  } = props;

  const filteredPayload = filterPayload ? filterPayload(payload) : payload;

  return (
    <Box css={{ display: 'flex', gap: '400', justifyContent: 'center' }}>
      {filteredPayload.map((entry: any, index: number) => {
        const labelType = labelTypes[entry.value] || 'default';

        return (
          <div key={`item-${index}`} style={{ cursor: 'pointer' }}>
            {getLabelTypeAdornment(labelType, entry)}
            {formatter(entry.value)}
          </div>
        );
      })}
    </Box>
  );
};
